import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { OrganisationManuscriptProcessingPage } from "~/pages/Settings/Organisations/organisation/manuscript-processing/OrganisationManuscriptProcessingPage";

export const Route = createFileRoute(
  "/_app/settings/organisations/$organisationId/manuscript-processing",
)({
  head: () => ({
    meta: [{ title: i18n.t("general:documentTitle.manuscriptProcessing") }],
  }),
  component: OrganisationManuscriptProcessingPage,
});
